import { createFileRoute } from "@tanstack/react-router";
import AlphaPage from "@/features/public/pages/alpha";

export const Route = createFileRoute("/(public)/_public/products/alpha")({
  component: AlphaPage,
});
